import HeaderCharmType from '../store/schema/HeaderCharmType';
import deactivateCharm from '../actions/deactivateCharm';
import { deactivateHelpCharmAction } from 'owa-uservoice';
import { orchestrator } from 'satcheljs';

export default orchestrator(deactivateHelpCharmAction, function hideSettings() {
    deactivateCharm(HeaderCharmType.HelpCharm);
});
